import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Tooltip } from "@mui/material";
import Swal from "sweetalert2";
import "./table.css";

function ReportTable({ savedReports }) {
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    reportTitle: { value: null, matchMode: FilterMatchMode.CONTAINS },
    reportStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
    completionTimeline: { value: null, matchMode: FilterMatchMode.CONTAINS },
    reportingPeriod: { value: null, matchMode: FilterMatchMode.CONTAINS },
    updatedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  useEffect(() => {
    fetchReports();
  }, []);

  const formatDate = (date) => {
    return date ? new Date(date).toLocaleDateString() : "";
  };

  const handleDelete = (index) => {
    const updatedReports = [...reports];
    updatedReports.splice(index, 1);
    setReports(updatedReports);
    localStorage.setItem("savedReports", JSON.stringify(updatedReports));
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <span className="p-input-icon-left">
          <img src="assets/img/search.png" className="search-i" alt="search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search"
          />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  async function fetchReports() {
    const companyid = localStorage.getItem("companyid");
    var myHeaders = new Headers();
    myHeaders.append("companyid", companyid);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    setLoading(true);
    try {
      setIsLoading(true);
      const response = await fetch(
        "https://ecoprism-prod-node.azurewebsites.net/allreports",
        requestOptions
      );
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success === false) {
          console.log(responseJson);
          setReports([]);
        } else if (responseJson.status === 400) {
          setReports([]);
        } else {
          setReports(responseJson.data);
        }
      } else {
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">Something Went Wrong</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
        setReports([]);
      }

      setIsLoading(false);
    } catch (error) {
      setLoading(false);
      setIsLoading(false);
      console.error(error);
    }
  }

  return (
    <div className="datatable-responsive">
      <DataTable
        value={reports}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 20, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        dataKey="id"
        filters={filters}
        filterDisplay="row"
        globalFilterFields={[
          "reportTitle",
          "reportStatus",
          "completionTimeline",
          "reportingPeriod",
          "updatedBy",
        ]}
        header={header}
        emptyMessage="No data found."
      >
        <Column
          header=""
          body={(rowData, rowIndex) => (
            <div>
              <Tooltip title="Edit" arrow>
                <Link to="">
                  <img
                    src="./assets/img/reports/edit.png"
                    alt="Edit Icon"
                    className="edit-icon actions-icon"
                  />
                </Link>
              </Tooltip>
              <Tooltip title="Status" arrow>
                <Link to="/reportDashboard">
                  <img
                    src="./assets/img/reports/Status.svg"
                    alt="Reports Icon"
                    className="reports-icon actions-icon"
                  />
                </Link>
              </Tooltip>
              <Tooltip title="Delete" arrow>
                <img
                  src="./assets/img/reports/delete.png"
                  alt="Delete Icon"
                  className="delete-icon actions-icon"
                  onClick={() => handleDelete(rowIndex)}
                />
              </Tooltip>
            </div>
          )}
          style={{ minWidth: "6rem" }}
        />
        <Column
          sortable
          field="reportTitle"
          header="Reports"
          filter
          filterPlaceholder="Filter"
          style={{ minWidth: "8rem" }}
        />
        
        <Column
          sortable
          field="reportStatus"
          header="Status"
          filter
          filterPlaceholder="Filter"
          style={{ minWidth: "8rem",color:'#FAB430' }}
        />

        <Column
          sortable
          field="completionTimeline"
          header="Completion Timeline"
          filter
          filterPlaceholder="Filter"
          style={{ minWidth: "8rem" }}
        />

        <Column
          sortable
          field="reportingPeriod"
          header="Reporting Period"
          filter
          filterPlaceholder="Filter"
          style={{ minWidth: "8rem" }}
        />
        
        <Column
          sortable
          field="updatedBy"
          header="Creator"
          filter
          filterPlaceholder="Filter"
          style={{ minWidth: "10rem" }}
        />
      </DataTable>
    </div>
  );
}

export default ReportTable;
